import { css } from "@emotion/react";

export const video = css`
  width: 100%;
  display: block;
  filter: blur(0.0000001px);
`;
